import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreparedPopupGeneratedRecordInterface } from '@app/store/models/prepared-popup-generated-record.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { Subject } from 'rxjs';
import { ErrorCode, PublicQrDetails, QrGeneratorNavigatorFEEDBACK, QrGeneratorNavigatorFEEDBACK_QUESTION } from 'shared-library';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-qrs-feedback',
  templateUrl: './qrs-feedback.component.html',
  styleUrls: ['./qrs-feedback.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsFeedbackComponent implements OnInit {

  steps = 0
  level1_index = -1
  level2_index = -1

  submitting = false

  data_ori: string
  @Input() qr_url: string;
  @Input() short_id: string
  @Input() social_data: SocialHelper
  @Input() qr_details: PublicQrDetails
  data: QrGeneratorNavigatorFEEDBACK
  @Output() _error = new EventEmitter<ErrorCode>()
  success_popup_obs: Subject<PreparedPopupGeneratedRecordInterface> = new Subject<PreparedPopupGeneratedRecordInterface>()

  constructor(
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
    if (!this.short_id) {
      throw new Error("Short id is required");
    }
    if (!this.qr_details) {
      throw new Error("Qr Details is required");
    }
    this.data = this.qr_details.feedback_data as QrGeneratorNavigatorFEEDBACK
    this.data_ori = JSON.stringify(this.data)
  }

  resetSteps() {
    if (this.level1_index > -1) {
      if (this.data.feedback.questions.length > this.level1_index) this.level1_index = -1
      else if (this.data.feedback.questions[this.level1_index].subs.length > this.level2_index) this.level2_index = -1
    }
    if (this.level1_index === -1 && this.level2_index > -1) this.level2_index = -1
    this.steps = 0
  }

  shouldSavenContinue(): boolean {
    if (!this.data.feedback.questions.length) return false
    if (this.data.feedback.questions.length > 1) return true
    return this.data.feedback.questions[0].subs.length > 1
  }

  shouldShowSend(): boolean {
    if (this.steps > 1) return false
    let _all_feedbacks_filled = true
    for (const temp of this.data.feedback.questions) {
      if (!this.allResponseReceived(temp)) {
        _all_feedbacks_filled = false
        break
      }
      if (temp.subs.length) {
        if (temp.subs.find(s => !this.allResponseReceived(s))) {
          _all_feedbacks_filled = false
          break
        }
      }
    }

    if (_all_feedbacks_filled) return true
    if (this.level1_index === -1) return false
    let in_feedback_view = (this.level2_index > -1 || !this.data.feedback.questions[this.level1_index].subs.length)
    let at_least_one_response_given = false
    for (const d of this.data.feedback.questions) {
      if (!d.subs.length) {
        if (d.feedback.rating || (d.feedback.description && d.feedback.description.trim())) {
          at_least_one_response_given = true
          break
        }
        continue
      }
      for (const dd of d.subs) {
        if (dd.feedback.rating || (dd.feedback.description && dd.feedback.description.trim())) {
          at_least_one_response_given = true
          break
        }
      }
    }
    let in_sub_view = this.level2_index === -1
    return (in_feedback_view || in_sub_view) && at_least_one_response_given
  }

  allResponseReceived(q: QrGeneratorNavigatorFEEDBACK_QUESTION): boolean {
    if (!q.subs.length) {
      return q.feedback.rating ? true : false
    }
    return q.subs.find(s => !s.feedback.rating) ? false : true
  }

  async startSubmit() {

    if (this.submitting) return

    if (!this.steps) {
      this.steps++
      return
    }

    this.submitting = true
    try {
      await this.coreService.submitQRResponses(this.short_id, { ...this.data.feedback, visit_info: this.qrGeneratorService.visitInfo() })
      this.steps++
      this.success_popup_obs.next(this.qr_details?.popups?.success)
      this.data = JSON.parse(this.data_ori)
    } catch (error) {
      this._error.emit(ErrorCode.SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST)
    }
    this.submitting = false
  }


}
